import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMUgcEpisodeApi = createApi({
  reducerPath: 'lMUgcEpisodeApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['UgcEpisodeLinks'],
  endpoints: builder => ({
    getUgcEpisodeLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-episode-level/`,
        params,
      }),
      providesTags: ['UgcEpisodeLinks']
    }),
    
    getUgcEpisodeLink: builder.query({
      query: id => `/links/ugc-episode-level/${id}/`,
      providesTags: ['UgcEpisodeLinks']
    }),

    getUgcEpisodeAggregateLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-episode-level/aggregate-by-campaign/`,
        params
      }),
      providesTags: ['UgcEpisodeLinks']
    }),
    getUgcEpisodeAggregateDomain: builder.query({
      query: ({ campaignId, ...params }) => ({
        url: `/links/ugc-episode/${campaignId}/aggregate-by-domain/`,
        params,
      }),
      providesTags: ['UgcEpisodeLinks']
    }),
    markUgcEpisode: builder.mutation({
      query: body => ({
        url: `/links/ugc-episode-level/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcEpisodeLinks']
    })
  })
})

export const {
  useGetUgcEpisodeLinksQuery,
  useLazyGetUgcEpisodeLinksQuery,
  useLazyGetUgcEpisodeLinkQuery,
  useGetUgcEpisodeAggregateLinksQuery,
  useGetUgcEpisodeAggregateDomainQuery,
  useLazyGetUgcEpisodeAggregateDomainQuery,
  useMarkUgcEpisodeMutation
} = lMUgcEpisodeApi
